<template>
  <div class="mian">
    <div class="nav">
    <van-nav-bar
        title="智能导诊"
        left-arrow
        left-text="返回"
        @click-left="onClickLeft"
      />
      <div class="top"></div>
    </div>
     <div class="symptomlist" v-if="!errfalg">
      <van-cell-group>
          <van-cell v-for="(item,index) in deptlist" :key="index" :title="item.diseaseName" is-link @click="godeptlist(item.deptName,item.diseaseName)" />
  
           </van-cell-group>
       </div>
         <div v-if="errfalg">
            <van-empty image="https://account.kmmds.top/datainfo_pic/error.png" description="暂无病症" />
          </div>
     </div>
  </div>
</template>

<script>
import Nav from "@/components/nav";
import { Dialog } from 'vant';
export default {
  data() {
    return {
      imgname: "MMZ",
      active: 0,
      tabfalg: true,
      listfalg: false,
      // bg_img: {
      //   height: "90vh",
      //   width: "100%",
      //   backgroundImage:
      //     "url(" + require("../../assets/Guidance/MMZ.png") + ")",
      // },
      sex: "",
      age: "",
      name: "",
      deptlist: {},
      errfalg: false,
    };
  },
  components: {
    Nav,
  },
  mounted() {
    if (this.$route.query) {
      this.sex = this.$route.query.sex;
      this.age = this.$route.query.age;
      this.name = this.$route.query.name;
    }

    this.querydiseasebywhere();
  },
  methods: {
    godeptlist(name,diseaseName) {
      Dialog.confirm({
        title: diseaseName,
        message: `建议前往${name}就诊，是否立即挂号`,
      })
        .then(() => {
          // on confirm
          this.$router.push('/querydept_C')
        })
        .catch(() => {
          // on cancel
        });
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    asa(event) {
      console.log("asa", event);
    },
    changelist() {
      this.tabfalg = !this.tabfalg;
    },
    async querydiseasebywhere() {
      //请求医院信息
      // 医院的名字、地址、banner图片、图标、功能
      try {
        this.$showLoad();
        this.isLoad = true;
        let url = "/register/querydiseasebywhere";
        let data = {
          bodyPartName: this.name,
          genderFlag: this.sex,
          ageFlag: this.age,
        };
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "post",
          data,
          (data) => {
            this.$hideLoad();

            if (data.data.length == 0) {
              this.errfalg = true;
            } else {
              this.deptlist = data.data;
            }
          }
        );
      } catch (error) {
        console.log(error);
        this.isLoad = false;
        this.$hideLoad();
        this.$toast.fail("网络连接失败");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.mian {
  display: flex;
  flex-direction: column;
  max-width: 100vh;
  background-color: #f7f7f7;
  height: 100vh;
  .nav {
    .top {
      height: 1vh;
    }
  }
  .symptomlist {
    width: 95vw;
    margin: 0 auto;
    .van-cell {
      position: relative;
      display: -webkit-box;
      display: -webkit-flex;
      display: flex;
      box-sizing: border-box;
      width: 100%;
      padding: 10px 16px;
      overflow: hidden;
      color: #323233;
      font-size: 14px;
      line-height: 40px;
      background-color: #fff;
    }
  }
}
</style>